import * as Raven from "raven-js";
var windowG = window;
windowG.jQuery = require("jquery");
var angular = require("angular");
var angularPlugin = require("raven-js/plugins/angular");
Raven.config(SENTRY_KEY, {
    release: CLIENT_INFO.version,
    autoBreadcrumbs: false,
    environment: "" + WHISPEER_ENV
})
    .addPlugin(angularPlugin, angular)
    .install();



//////////////////
// WEBPACK FOOTER
// ./js/ravenConfigAngular.ts
// module id = hWdg
// module chunks = 1 2 3 4 5